type SendMerchantGroupAdminLoginLinkBody = {
  email: string
}

export const sendMerchantGroupAdminLoginLink = async (
  payload: SendMerchantGroupAdminLoginLinkBody
) => {
  await api.post(
    "/merchant-groups/admins/send-login-link/",
    {
      body: payload,
    }
  )
  return
}
